import cn from "classnames";

import { ComponentType, StrapiComponentType } from "@/src/type";

import SectionModule from "../../../../partial/__module__/SectionModule/SectionModule";
import { ButtonLinkModule, TextBreakpointModule } from "@/src/component/partial/__module__";

import styles from "./MutliCTAGroup.module.scss";

interface MultiCTAGroupProps extends ComponentType.DynamicPageSectionComponentProps<StrapiComponentType.Section.MutliCTAGroup> {}

export function MultiCTAGroup({ section, slug, snapToGrid, lazy, searchParams, quality, mobileHint, deviceWidthHint, layout }: MultiCTAGroupProps) {
  const multiCTAGroup: StrapiComponentType.Section.MutliCTAGroup = section.type?.[0];

  return (
    <SectionModule
      section={section}
      slug={slug}
      snapToGrid={snapToGrid}
      lazy={lazy}
      styleContainerId={multiCTAGroup.id}
      searchParams={searchParams}
      mobileHint={mobileHint}
      deviceWidthHint={deviceWidthHint}
      quality={quality}
      stylePrefix="MultiCTAGroup"
      layout={layout}
      classes={{
        styledContainer: styles.container,
      }}
    >
      <>
        <div className={`${styles.header} ${multiCTAGroup.items?.length === 2 ? styles.distanced : ""}`}>
          <TextBreakpointModule
            id={`multi_cta_group_title_${multiCTAGroup.id}`}
            text={section.title}
            className={styles.title}
          />
          <TextBreakpointModule
            id={`multi_cta_group_location_${multiCTAGroup.id}`}
            text={multiCTAGroup.nextToTitle}
            className={styles.location}
          />
        </div>
        {!!multiCTAGroup.items?.length && (
          <div className={`${styles.groups}`}>
            {multiCTAGroup.items.map(({ title, ctas, description }, groupIndex) => {
              const hasTwoButtons = (ctas ?? []).length === 2;
              return (
                <div
                  className={styles.group}
                  key={groupIndex}
                >
                  <TextBreakpointModule
                    id={`multi_cta_group_title_${multiCTAGroup.id}_${groupIndex}`}
                    text={title}
                    className={styles.groupTitle}
                  />
                  <TextBreakpointModule
                    id={`multi_cta_group_description_${multiCTAGroup.id}_${groupIndex}`}
                    text={description}
                    className={styles.groupDescription}
                  />

                  {!!ctas?.length && (
                    <div className={styles.ctaContainer}>
                      {ctas.map((cta, index) => (
                        <ButtonLinkModule
                          key={index}
                          buttonLink={cta}
                          className={cn(styles.cta, hasTwoButtons ? styles.cta2x : undefined)}
                        />
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </>
    </SectionModule>
  );
}
